import { getCurrentMillis } from '../utils/date.utils';
import { ManufacturingOrder } from './manufacturing-order';
import { SchedulerTaskPrint } from './scheduler-task-print';
import { SchedulerTaskProgram } from './scheduler-task-program';
import { SchedulerTaskPutAdditionalTime } from './scheduler-task-put-additional-time';
import { SchedulerTaskRemoveAdditionalTime } from './scheduler-task-remove-additional-time';
import { SchedulerTaskStatus } from './scheduler-task-status';
import { SchedulerTaskSubTask } from './scheduler-task-sub-task';
import { Warning } from './warning';

export class SchedulerTask {
  public open: boolean;
  public position: number;
  public duration: number;
  public formatedDuration: number;
  public taskDuration: number;
  public durationPutAdditionalTime: number;
  public durationRemoveAdditionalTime: number;
  public programs: SchedulerTaskProgram[];

  constructor(
    public hash?: string,
    public model?: string,
    public startDate?: number,
    public endDate?: number,
    public identifier?: string,
    public prints?: SchedulerTaskPrint[],
    public updatable?: boolean,
    public created?: boolean,
    public preparing?: boolean,
    public ready?: boolean,
    public error?: boolean,
    public issue?: boolean,
    public running?: boolean,
    public current?: boolean,
    public finished?: boolean,
    public putAdditionalTime?: SchedulerTaskPutAdditionalTime,
    public removeAdditionalTime?: SchedulerTaskRemoveAdditionalTime,
    public deviation?: number,
    public subTasks?: SchedulerTaskSubTask[],
    public started?: boolean,
    public hasParent?: boolean,
    public statuses?: SchedulerTaskStatus[],
    public activeStatus?: SchedulerTaskStatus,
    public project?: string,
    public deliveryDate?: string,
    public code?: number,
    public quantity?: number,
    public manufacturingOrder?: ManufacturingOrder,
    public schedulerTaskPrograms?: SchedulerTaskProgram[],
    public warning?: Warning,
    public pendingProgramDefinition?: boolean,
    public programDefinition?: string,
    public blocked?: boolean,
    public formatedStartDate?: number,
    public formatedEndDate?: number,
    public toolDeliveryDate?: number,
    public toolLocation?: string,
    public toolTable?: boolean
  ) { }

  get putToolTime() {
    return this.putAdditionalTime ? this.putAdditionalTime.putToolTime : null;
  }

  get removeToolTime() {
    return this.removeAdditionalTime
      ? this.removeAdditionalTime.removeToolTime
      : null;
  }

  get putPieceTime() {
    return this.putAdditionalTime ? this.putAdditionalTime.putPieceTime : null;
  }

  get removePieceTime() {
    return this.removeAdditionalTime
      ? this.removeAdditionalTime.removePieceTime
      : null;
  }

  get putTotalAdditionalTime() {
    return (
      (this.putToolTime ? this.putToolTime : 0) +
      (this.putPieceTime ? this.putPieceTime : 0)
    );
  }

  get removeTotalAdditionalTime() {
    return (
      (this.removeToolTime ? this.removeToolTime : 0) +
      (this.removePieceTime ? this.removePieceTime : 0)
    );
  }

  get totalAdditionalTime() {
    return (
      (this.putToolTime ? this.putToolTime : 0) +
      (this.removeToolTime ? this.removeToolTime : 0) +
      (this.putPieceTime ? this.putPieceTime : 0) +
      (this.removePieceTime ? this.removePieceTime : 0)
    );
  }

  toggleOpen() {
    this.open = !this.open;
  }

  get progressDuration() {
    return this.endDate - this.startDate;
  }

  setStatus(task: SchedulerTask) {
    this.created = task.created;
    this.preparing = task.preparing;
    this.ready = task.ready;
    this.error = task.error;
    this.issue = task.issue;
    this.running = task.running;
  }

  clone() {
    return new SchedulerTask(
      this.hash,
      this.model,
      this.startDate,
      this.endDate,
      this.identifier,
      this.prints,
      this.updatable,
      this.created,
      this.preparing,
      this.ready,
      this.error,
      this.issue,
      this.running,
      this.current,
      this.finished,
      this.putAdditionalTime,
      this.removeAdditionalTime,
      this.deviation,
      this.subTasks,
      this.hasParent
    );
  }

  get hasToolWithAcutalDeliveryDate() {
    return this.toolDeliveryDate && this.toolDeliveryDate > getCurrentMillis();
  }

  get hasLocationTool() {
    return this.toolLocation && this.toolLocation !== '';
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task.ts